// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wait":"wait___2OEGW","header":"header___34i26","title":"title___VNfZT","status-cta":"status-cta___3_IqR","body":"body___3ZsAy","cards":"cards___2_8_D"};